import { Dispatch } from 'redux';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { getErrorJson } from '@mm/utils';
import { FORM } from '@mm/constants/widgets';
import { showWidgetErrorModal } from '../actions/networkActions';
import { FormEntry } from '../model/FormsModel';
import { StoreState } from '../store-interfaces';
import commonHandler from './common-handler';

export const update = () => (error: Response) => {
  if (error.status === 422) {
    return getErrorJson(error);
  }

  throw error;
};

const clearValidationFailedText = text => {
  const regexp = /Validation\sfailed:\s(.*)/;

  return text.match(regexp)[1] || '';
};

export const failedValidationHandler =
  (dispatch: Dispatch<StoreState>, widget: FormEntry) =>
  async (error: Response) => {
    const responseError = await getErrorJson(error);
    const isUserForm = widget.type === FORM;
    let text = '';

    if (responseError && Array.isArray(responseError.errors)) {
      text += responseError.errors.join(' \n');
    }

    if (isUserForm && error.status === UNPROCESSABLE_ENTITY) {
      dispatch(showWidgetErrorModal(clearValidationFailedText(text)));
    } else {
      await commonHandler(dispatch)(error);
      throw error;
    }
  };
